<template>
    <div>
        <my-form 
            class="form-page" 
            v-model="form" table 
            label-width="180px" 
            @cancle="cancleHandler" 
            @submit="fsave">
            <el-form-item 
                label="评分点名称" 
                prop="nodecaption" 
                class="table-full-row"
                :rules="newRule('评分点名称', 'required')">
                    <el-input 
                        type="textarea" 
                        :autosize="{ minRows: 4, maxRows: 10}"
                        v-model="form.nodecaption">
                    </el-input>
            </el-form-item>
            <el-form-item 
                label="描述" 
                prop="standard" 
                class="table-full-row"
                :rules="newRule('描述', 'required')">
                    <el-input 
                        type="textarea" 
                        :autosize="{ minRows: 4, maxRows: 10}"
                        v-model="form.standard">
                    </el-input>
            </el-form-item>
            <el-form-item 
                label="打分区间（最小值---最大值）" 
                prop="lowerlimit" 
                class="table-full-row"
                :rules="newRule('最小值', 'required')">
                    <el-input-number 
                        style="width:200px"
                        v-model="form.lowerlimit" 
                        :min="0"
                        :controls="false"
                        :precision="2">
                    </el-input-number>
                    --
                    <el-input
                        style="width:200px"
                        disabled
                        v-model="form.upperlimit">
                    </el-input>
            </el-form-item>
            <el-form-item 
                label="固定分值" 
                prop="backup2" 
                class="table-full-row"
                :rules="newRule('固定分值', 'required')">
                    <el-input
                        @blur="checkGdz(form.backup2)"
                        v-model="form.backup2">
                    </el-input>
                    <my-tag type="danger" v-if="qdgdz">只能包含数字、小数点、‘-’和英文逗号</my-tag>
                    <my-tag type="danger" v-if="gdz">只能包含数字、小数点和英文逗号</my-tag>
            </el-form-item>
            <template slot="btn" slot-scope="scope">
                <ca-activation type="primary" icon="el-icon-circle-check" @click="saveHandler(scope.submitHandler,$event)">
                    提交
                </ca-activation>
                <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
            </template>
        </my-form>

    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'

import CaActivation from '@/components-sys/ca-activation'
export default {
    mixins: [ FORM_PAGE_MIXIN],
    components: {
        CaActivation,
    },
    data: () => ({
        form:{},
        formData:{},
        ruledefault:{},
        qdgdz:false,
        gdz:false,
        caObjectVal:{},
    }),
    computed: {
     
    },
    methods: {
        // 判断固定分值
        checkGdz(num){
            var reg = /^[0-9,.]+$/g;
            var reg1 = /^[0-9,.-]+$/g;
            if(this.formData.filecontenttype==='1'){
                if($.trim(num) != '' && !reg1.test(num)){
                    this.qdgdz = true
                    return this.qdgdz
                }else{
                    this.qdgdz = false
                    return this.qdgdz
                }
            }else{
                if ($.trim(num) != '' && !reg.test(num)) {
                    this.gdz = true
                    return this.gdz
                }else{
                    this.gdz = false
                    return this.gdz
                }
            }
        },
        // 保存
        saveHandler(cb,type){
            
            var that = this
            that.form.caType = type
            if(Number(that.form.lowerlimit) >= Number(that.form.upperlimit)){
                ShowMsg('打分最小值应小于最大值！','warning')
                return
            }
            
            cb && cb();
        },
        fsave(){
            var that = this
            if(!that.checkGdz(that.form.backup2)){
               that.caObjectVal.character = that.form.bdcode+ "$$$" + that.form.nodekey + "$$$hzb";
               //签名
                useCA(that.form.caType, 'sign', that.caObjectVal, function (res) {
                    that.form.sData = res.signData;
                        //获取证书对象
                    useCA(that.form.caType, 'getCertB64', that.objectVal, function (res) {
                        that.form.sCert = res.signCert;
                        //ca单位名称
                        useCA(that.form.caType, 'getcadwname', that.objectVal, function (res) {
                            if (that.formData.dwname == res.cadwname) {
                                that.form.filecontenttype = that.formData.filecontenttype
                                $.post(`${that.getGetters('ageUrl')}/FaBiao/ZbFile/`+that.getQuery('type')+`/nodedetail/edit.json`, that.form, data => {
                                    if(data.result){
                                        ShowMsg('保存成功', 'success');
                                        that.$router.go(-1);
                                    }else{
                                        ShowMsg(data.msg,'warning')
                                    }
                                });
                            }else{
                                ShowMsg('CA单位名称与当前登录单位名称不一致！', 'error');
                            }
                        })
                    })
                })
                
            }
        }
    },
    created() {
        var that = this
        that.jspInit(`${that.getGetters('ageUrl')}/FaBiao/ZbFile/`+that.getQuery('type')+`/nodedetail.json`,{
            bdcode:that.getQuery('bdcode'),
            nodeid:that.getQuery('nodeid'),
            filecontenttype:that.getQuery('filecontenttype'),
        },(data, res) => {
            that.form = data.model
            that.formData = data
        });
    },
    mounted() {
       
    },
}
</script>

<style scoped lang="scss">
/deep/ .el-input.is-disabled .el-input__inner{ color: #333; }
// /deep/ .el-input-number__decrease,/deep/  .el-input-number__increase{ display: none;}
</style>
